module.exports = __webpack_public_path__ + "img/监管者.267960c4.png";